export default class SelectionQuizCAnswer {
  constructor(public readonly choiceId: string) {}
}
